import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';

type PreviewLogoClickedInput = {
    location: 'Thumbnail' | 'Link';
};

const { LOCATION } = MIXPANEL_EVENT_PROPERTIES;

export const reportPreviewLogoClicked = ({
    location,
}: PreviewLogoClickedInput) => {
    const payload = {
        ...getDataFromStores(
            store.user,
            store.userActivated,
            store.pagePath,
            store.brief,
            store.variationId,
            store.projectId,
            store.sellerId,
            store.orderType,
            store.fromBoost
        ),
        [LOCATION]: location,
    };

    mixpanel.track('Logo Maker - Packages Page - Preview Your Logo', payload);
};
